import React from 'react';
import { BKJLoadingSpinner } from '@bookjane2/bookjane-design-library';
import { WidgetCardWrapperProps } from 'pages/ReportsPage/components/AnalyticsDashboards/WidgetCardWrapper/WidgetCardWrapper.types';
import {
  WidgetCard,
  WidgetCardHeader,
  WidgetCardHeadings,
  WidgetCardHeaderAction,
  WidgetCardTitle,
  WidgetCardSubtitle,
  WidgetCardContent,
  WidgetCardLoadingContainer,
} from 'pages/ReportsPage/components/AnalyticsDashboards/WidgetCardWrapper/WidgetCardWrapper.styled';

export const WidgetCardWrapper: React.FC<WidgetCardWrapperProps> = ({
  title,
  subtitle,
  loading,
  headerAction,
  children,
}) => {
  return (
    <WidgetCard>
      <WidgetCardHeader>
        <WidgetCardHeadings>
          <WidgetCardTitle>{title}</WidgetCardTitle>
          {subtitle && <WidgetCardSubtitle>{subtitle}</WidgetCardSubtitle>}
        </WidgetCardHeadings>
        {headerAction && <WidgetCardHeaderAction>{headerAction}</WidgetCardHeaderAction>}
      </WidgetCardHeader>
      {loading ? (
        <WidgetCardLoadingContainer>
          <BKJLoadingSpinner variant="Default" />
        </WidgetCardLoadingContainer>
      ) : (
        <WidgetCardContent>{children}</WidgetCardContent>
      )}
    </WidgetCard>
  );
};
